module.exports = __webpack_public_path__ + "img/system.47bf0a4a.svg";